import sentGAEvent from ".";
/**
 * 登录页面出现曝光埋点
 */
const GALoginPageDisplay = () => {
  sentGAEvent({
    category: "login",
    action: "login_display",
  });
};

/**
 * 点击登录按钮
 * @param {string} label
 */
const GALoginClickConfirm = label => {
  sentGAEvent({
    category: "login",
    action: "login_confirm_click",
    label,
  });
};

/**
 * 登录表单格式报错
 * @param {string} label
 */
const GALoginFromError = label => {
  sentGAEvent({
    category: "login",
    action: "login_error",
    label,
  });
};

/**
 * 登录页面跳转sign up页面
 */
const GALoginClickToSignUp = () => {
  sentGAEvent({
    category: "login",
    action: "login_to_sign",
  });
};

/**
 * 注册页面跳转service页面
 */
const GALoginClickToService = () => {
  sentGAEvent({
    category: "login",
    action: "login_services_click",
  });
};

/**
 * 注册页面跳转privacy页面
 */
const GALoginClickToPrivacy = () => {
  sentGAEvent({
    category: "login",
    action: "login_privacy_click",
  });
};

export { GALoginPageDisplay, GALoginClickConfirm, GALoginFromError, GALoginClickToSignUp, GALoginClickToPrivacy, GALoginClickToService };
